import type { ClientConfigServerType } from '@/services/client-config/clientConfig';
import { Any } from '@/shared/constant/any';
import { createContextStore } from '@/shared/util/createContextStore';

export type ClientConfigState = ClientConfigServerType;

export type ClientConfigAction = {};

const [ClientConfigModelStoreProvider, useClientConfigModelStore] = createContextStore<
  ClientConfigState,
  ClientConfigAction
>(
  () => ({
    ...Any,
  }),
  false,
);

export { ClientConfigModelStoreProvider, useClientConfigModelStore };
